<template>
	<div>
		<Modal 
			:loading="loading" 
			:title="'SELECIONAR ENDEREÇO'"
			@close="close"
			@save="save"
		>
			<div class="row">
				<div class="col-xs">
					<small><b>Informações de endereço</b></small>
				</div>
			</div>
			<form-group-address
				:current_id="receiver.fk_address"
				:current_postal_code="receiver.postal_code"
				:current_street="receiver.street"
				:current_number="receiver.number"
				:current_complement="receiver.complement"
				:current_neighborhood="receiver.neighborhood"
				:current_city="receiver.city"
				:current_uf="receiver.uf"
				:current_country="receiver.country"
				:current_coordinates="receiver.coordinates"
				ref="formGroup"
			>
			</form-group-address>
		</Modal>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormGroupAddress from '@/components/FormGroupAddress.vue';

export default {
	name: "DeliveryFormAddress",

	props: {
		current: {
			type: [Object, String],
			required: true,
		},
	},

	components: {
		Modal,
		FormGroupAddress,
	},

	data: function() {
		return {
			loading: false,
			receiver: {
				postal_code: '',
				street: '',
				number: '',
				complement: '',
				neighborhood: '',
				city: '',
				uf: '',
				country: '',
				coordinates: null,
			},
		};
	},

	methods: {
		// Verifica e valida inicialmente os campos
		validation: function() {
			let data = [];
			let dataOrder = {};
			let error = false;

			let dataAddress = this.$refs.formGroup.validation();
			if (dataAddress) {
                Object.assign(dataOrder, {
                    postal_code: dataAddress.postal_code,
                    street: dataAddress.street,
                    number: dataAddress.number,
                    complement: dataAddress.complement,
                    neighborhood: dataAddress.neighborhood,
                    city: dataAddress.city,
                    uf: dataAddress.uf,
                    country: dataAddress.country,
                    coordinates: dataAddress.coordinates.lat + "," + dataAddress.coordinates.lng,
                });
			} else {
				error = true;
			}

            data.push(dataOrder);

			// Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
		},

		// Retorna menssagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

		// Envia para API e salva as informações no BD
        save: async function() {
			let form = {};

			let confirm = await this.$alert.confirm("Deseja mesmo selecionar esse endereço?");
            if (!confirm) return;

            form.id = this.current.id;

			let data = this.validation();
			
			if (data == null) {
				return;
			}
			
			form.data = data;
			
			this.loading = true;
			let result = null;
			try {
				result = await Api.post("delivery/save-address", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível processar as informações.");
				this.loading = false;
				return;
			}
			this.loading = false;
			
			if (result != null) {
				if (result.error) {
					this.$notification.error(result.data);
				} else {
					this.$notification.success("Entrega processada com sucesso.");
					this.close();
				}
			} else {
				this.$notification.error("Não foi possível processar as informações.");
			}
			return;
		},

		// Fecha o modal
		close: function() {
			this.$parent.show_modal_address = false;
			this.$parent.current_form = null;
			this.$parent.load();
		},
	}
}
</script>

<style scoped></style>